import { Spin } from "antd";
import { NO_RESULT_FOUND } from "@/constants/strings.ts";
import { Images } from "@/constants/images.tsx";

export interface IEmptyBoxProps {
  loading: boolean;
}

const EmptyBox = (props: IEmptyBoxProps) => {
  const { loading } = props;

  return (
    <Spin spinning={loading}>
      <div className="flex flex-col items-center space-y-4">
        <div className="flex flex-col rounded-full bg-gray-100 items-center mb-3 w-12 h-12 justify-center ">
          <img src={Images.IconDocument} alt="" className=" object-contain" />
        </div>
        <span className="text-gray-900 text-[16px]">{NO_RESULT_FOUND}</span>
      </div>
    </Spin>
  );
};

export default EmptyBox;
